import { FrameLabel } from "./FrameLabel";

export class Scene {
    public readonly labels: FrameLabel | null = null;
    public readonly name: string = "";
    public readonly numFrames: number = 0;
}
